export const DEFAULT_PROFILE_PIC =
  'https://s3-ap-southeast-1.amazonaws.com/sourcesage.co/img/user-1.png';
export const DEFAULT_GROUP_CHAT_PIC =
  'https://s3-ap-southeast-1.amazonaws.com/sourcesage.co/img/GroupChat.png';
export const DEFAULT_CHANNEL_PIC =
  'https://s3-ap-southeast-1.amazonaws.com/sourcesage.co/img/channel-1.png';

export function makeProfileImageUrl(str = '', fallback = DEFAULT_PROFILE_PIC) {
  if (str) {
    if (str.match(/^images/)) {
      return `https://sourcesage.s3.amazonaws.com/${str}`;
    }
    if (str.match(/^https:\/\/sourcesage.s3.amazonaws.com/)) {
      return str;
    }
  }
  return fallback;
}

export function s3KeyToUrl(str = '') {
  if (str && str.match(/^images/)) {
    return `https://sourcesage.s3.amazonaws.com/${str}`;
  }
  return DEFAULT_PROFILE_PIC;
}



// WEBPACK FOOTER //
// ./app/utils/images.js